import { Stack, Typography } from '@mui/material';
import { CRMUserData } from '../../../@types/api';
import { styles } from './styles';

type CommissionTabHeaderProps = {
  user?: CRMUserData;
};

const CommissionTabHeader = ({ user }: CommissionTabHeaderProps) => (
  <Stack
    direction='row'
    sx={{
      justifyContent: 'space-between',
      p: 1,
    }}
  >
    <Typography sx={styles.userName}>{user?.fullName}</Typography>
    <Typography variant='h6'>{user?.teamLead?.fullName}</Typography>
  </Stack>
);

export default CommissionTabHeader;
